(function () {
  if (window.__cfCard) return;
  window.__cfCard = true;

  var KEEP = 3;
  var recent = [];

  /* The other colourways arrive as URLs in data-cfc-more and only become real
     images the first time the card is hovered. A page of forty eight products
     therefore loads forty eight images instead of just under three hundred. */
  function hydrate(card) {
    if (card.__cfHydrated) return;
    card.__cfHydrated = true;
    var more = card.getAttribute('data-cfc-more');
    if (!more) return;
    var frame = card.querySelector('.cfc__frame');
    if (!frame) return;
    var urls = more.split('|');
    for (var i = 0; i < urls.length; i++) {
      if (!urls[i]) continue;
      var img = document.createElement('img');
      img.setAttribute('data-cfc-img', '');
      img.alt = '';
      img.width = 600;
      img.height = 750;
      img.decoding = 'async';
      img.src = urls[i];
      frame.appendChild(img);
    }
  }

  /* Warm a card's colourways slightly before the pointer lands on it, so the
     first hover is as instant as the ones after it. */
  function warm(card) {
    if (card.__cfWarmed) return;
    card.__cfWarmed = true;
    window.setTimeout(function () { hydrate(card); }, 90);
  }

  function reveal(card, img) {
    var imgs = card.querySelectorAll('[data-cfc-img]');
    for (var j = 0; j < imgs.length; j++) imgs[j].classList.toggle('is-on', imgs[j] === img);
  }

  function swap(card) {
    hydrate(card);
    var imgs = card.querySelectorAll('[data-cfc-img]');
    if (imgs.length < 2) return;
    var pool = [];
    for (var i = 1; i < imgs.length; i++) if (recent.indexOf(i) === -1) pool.push(i);
    if (!pool.length) pool = [1];
    var pick = pool[Math.floor(Math.random() * pool.length)];
    recent.push(pick);
    if (recent.length > KEEP) recent.shift();

    var target = imgs[pick];
    card.__cfWant = target;

    /* Never fade to an image that has not arrived: that is a white flash. */
    if (target.complete && target.naturalWidth) {
      reveal(card, target);
    } else {
      target.addEventListener('load', function () {
        if (card.__cfIn && card.__cfWant === target) reveal(card, target);
      }, { once: true });
    }
  }

  function reset(card) {
    var imgs = card.querySelectorAll('[data-cfc-img]');
    card.__cfWant = null;
    for (var j = 0; j < imgs.length; j++) imgs[j].classList.toggle('is-on', j === 0);
  }

  function fill(btn) {
    if (btn.__f) return;
    btn.__f = true;
    var label = (btn.textContent || '').trim();
    btn.innerHTML = '';
    var base = document.createElement('span');
    base.className = 'cf-base';
    base.textContent = label;
    btn.appendChild(base);
    var i, el;
    for (i = 1; i <= 4; i++) { el = document.createElement('span'); el.className = 'cf-hh'; el.setAttribute('data-i', String(i)); el.setAttribute('aria-hidden', 'true'); btn.appendChild(el); }
    for (i = 1; i <= 4; i++) { el = document.createElement('span'); el.className = 'cf-hc'; el.setAttribute('data-i', String(i)); el.setAttribute('aria-hidden', 'true'); el.textContent = label; btn.appendChild(el); }
  }

  var back = null, sheet = null, current = null, chosen = null;

  function build() {
    if (sheet) return;
    back = document.createElement('div');
    back.className = 'cf-sheet-back';
    back.addEventListener('click', close);
    document.body.appendChild(back);
    sheet = document.createElement('div');
    sheet.className = 'cf-sheet';
    sheet.innerHTML = '<div class="cf-sheet__head"><img alt=""><div><p class="cf-sheet__title"></p><p class="cf-sheet__price"></p></div><button type="button" class="cf-sheet__close" aria-label="Close">&times;</button></div><p class="cf-sheet__label">Pick your iPhone</p><div class="cf-chips cf-chips--gen"></div><div class="cf-chips cf-chips--model"></div><button type="button" class="cf-sheet__add" disabled>Select a model</button>';
    document.body.appendChild(sheet);
    sheet.querySelector('.cf-sheet__close').addEventListener('click', close);
    sheet.querySelector('.cf-sheet__add').addEventListener('click', add);
  }

  function close() { if (sheet) { sheet.classList.remove('is-open'); back.classList.remove('is-open'); } }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function gen(t) { var m = /iphone\s*(\d+)/i.exec(t || ''); return m ? m[1] : null; }

  function models(g) {
    var row = sheet.querySelector('.cf-chips--model');
    row.innerHTML = '';
    chosen = null;
    var addBtn = sheet.querySelector('.cf-sheet__add');
    addBtn.disabled = true;
    addBtn.textContent = 'Select a model';
    var gens = sheet.querySelectorAll('.cf-chips--gen .cf-chip');
    for (var i = 0; i < gens.length; i++) gens[i].setAttribute('aria-pressed', gens[i].dataset.gen === g ? 'true' : 'false');
    current.variants.forEach(function (v) {
      if (gen(v.title) !== g) return;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'cf-chip';
      chip.textContent = v.title;
      chip.setAttribute('aria-pressed', 'false');
      chip.addEventListener('click', function () {
        chosen = v;
        var all = row.querySelectorAll('.cf-chip');
        for (var k = 0; k < all.length; k++) all[k].setAttribute('aria-pressed', all[k] === chip ? 'true' : 'false');
        addBtn.disabled = false;
        addBtn.textContent = 'Add to basket - ' + money(v.price);
      });
      row.appendChild(chip);
    });
  }

  function add() {
    if (!chosen) return;
    var btn = sheet.querySelector('.cf-sheet__add');
    btn.disabled = true;
    btn.textContent = 'Adding';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: chosen.id, quantity: 1 }) })
      .then(function () { close(); return fetch('/?sections=cart-drawer-section').then(function (r) { return r.json(); }); })
      .then(function (data) {
        var holder = document.getElementById('shopify-section-cart-drawer-section');
        if (holder && data['cart-drawer-section']) {
          var shell = document.createElement('div');
          shell.innerHTML = data['cart-drawer-section'];
          var fresh = shell.querySelector('#shopify-section-cart-drawer-section');
          holder.innerHTML = fresh ? fresh.innerHTML : data['cart-drawer-section'];
        }
        window.setTimeout(function () {
          var t = document.querySelector('[data-cf-cart]');
          if (t) t.click();
        }, 140);
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function open(handle) {
    build();
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      current = p;
      sheet.querySelector('.cf-sheet__head img').src = p.images && p.images[0] ? p.images[0] : '';
      sheet.querySelector('.cf-sheet__title').textContent = p.title;
      sheet.querySelector('.cf-sheet__price').textContent = money(p.price);
      var order = [];
      p.variants.forEach(function (v) { var g = gen(v.title); if (g && order.indexOf(g) === -1) order.push(g); });
      var row = sheet.querySelector('.cf-chips--gen');
      row.innerHTML = '';
      order.forEach(function (g) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cf-chip';
        chip.dataset.gen = g;
        chip.textContent = 'iPhone ' + g;
        chip.setAttribute('aria-pressed', 'false');
        chip.addEventListener('click', function () { models(g); });
        row.appendChild(chip);
      });
      sheet.querySelector('.cf-chips--model').innerHTML = '';
      sheet.querySelector('.cf-sheet__add').disabled = true;
      sheet.querySelector('.cf-sheet__add').textContent = 'Select a model';
      back.classList.add('is-open');
      sheet.classList.add('is-open');
    });
  }

  function wire() {
    var cards = document.querySelectorAll('[data-cfc]');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.__w) continue;
      c.__w = true;
      (function (card) {
        card.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'touch') return;
          card.__cfIn = true;
          swap(card);
        });
        card.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'touch') return;
          card.__cfIn = false;
          reset(card);
        });
        /* moving anywhere in the row is enough warning */
        var row = card.parentElement;
        if (row && !row.__cfWarm) {
          row.__cfWarm = true;
          row.addEventListener('pointermove', function (e) {
            if (e.pointerType === 'touch') return;
            var near = e.target.closest ? e.target.closest('[data-cfc]') : null;
            if (near) warm(near);
          }, { passive: true });
        }
        var btn = card.querySelector('[data-cfc-buy]');
        if (btn) {
          fill(btn);
          btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(card.getAttribute('data-cfc')); });
        }
      })(c);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  new MutationObserver(wire).observe(document.documentElement, { childList: true, subtree: true });
})();